<template lang="pug">
div
  app-dialog(v-model="$_show" header="Сменить пароль")
    v-form(ref="formPassword")
      app-text-field(
        v-model="form.password" 
        :append-icon="showPSWD ? 'mdi-eye' : 'mdi-eye-off'"
        :type="showPSWD ? 'text' : 'password'"
        :rules="[rules.required]"
        label="Пароль"
        @click:append="showPSWD = !showPSWD"
      )

      app-text-field(
        v-model="form.passwordConfirm" 
        :rules="[rules.required, passwordConfirmationRule]"
        :type="showPSWD ? 'text' : 'password'"
        hint="Неверный пароль"
        label="Повторите пароль"
      )
      app-button-action(@click="changePassword()") сменить

    app-dialog-loading(v-model="loading")

    
</template>

<script>
import { userService } from "@/_services";
import { $_validate_rules } from '@/common/ValidateRules'
import { AppDialogToggable } from '@/components'

export default {
  mixins: [AppDialogToggable, $_validate_rules],

  data () {
    return {
      form: {
        id: '',
        password:'',
        passwordConfirm: '',
      },
      showPSWD: false,
      loading: false
    }
  },

  computed: {
    passwordConfirmationRule () {
      return this.form.password === this.form.passwordConfirm || 'Неверный пароль'
    }
  },

  methods: {
    changePassword () {
      if (this.$refs.formPassword.validate()) {
        this.form.id = localStorage.getItem("useruuid")
        this.$_show = false
        this.loading = true
        userService.changePassword(this.form).then(() => this.loading = false)
      }
    }
  }
}
</script>